import * as z from "zod";
import { apiClient } from "../../common/apiClient";
import { logger } from "../../common/logger";
import type { Session } from "../../common/types/companyTypes";

type AuthSessionRequestOptions = {
   accessToken?: string | null;
   headers?: Record<string, string>;
   includeCredentials?: boolean;
};

const ZAuthSession = z.object({
   accessToken: z.string().min(1),
   expiry: z.string().min(1)
});

const summarizeZodError = (error: z.ZodError) =>
   error.issues.map((issue) => ({
      code: issue.code,
      message: issue.message,
      path: issue.path.join(".")
   }));

export const parseAuthSession = (response: unknown): Session => {
   const validation = z.safeParse(ZAuthSession, response);
   if (validation.success) {
      return validation.data;
   }

   logger.error("auth", "Invalid auth session response", summarizeZodError(validation.error));
   throw new Error("Invalid auth session response", { cause: validation.error });
};

export const authSessionRequest = (url: string, options: AuthSessionRequestOptions = {}) => {
   const { accessToken, headers, includeCredentials = false } = options;

   if (headers === undefined && !includeCredentials) {
      return accessToken === undefined ? apiClient(url) : apiClient(url, accessToken);
   }

   return apiClient(url, accessToken ?? null, undefined, {
      headers,
      credentials: includeCredentials ? "include" : undefined
   });
};
